import { BaseModel } from '../base.model';
import { required } from '../json-map.util';

class CourseRequest {}

namespace CourseRequest {


  export class Create extends BaseModel {

    @required()
    title: string = undefined;
    description: string = undefined;
    subject: string = undefined;
    country: string = undefined;

  }

  export class Update extends BaseModel {

    title: string = undefined;
    description: string = undefined;
    subject: string = undefined;
    lessonIds: number[] = undefined;
    country: string = undefined;

  }

}

export { CourseRequest };

